import { createSelector } from 'reselect';
import { CUSTOM_VIEWS_EDIT } from '../../constants/Scopes';
import { getScopes } from './getScopes';
export const getUserHasCustomViewsAccess = createSelector(getScopes, scopes => scopes.includes(CUSTOM_VIEWS_EDIT));